import AppTooltip from "@/common/components/Tooltip/AppTooltip";
import { EnvHelper } from "@/common/helpers/env";
import { ApiEnumName } from "@/common/services/enum";
import { TenantMode } from "@/core/api/generated/v1";

import AppChip, { AppChipProps } from "../../Chip/AppChip";
import InlineApiEnumValue from "../../Enum/InlineApiEnumValue";

interface Props extends Partial<AppChipProps> {
  mode: TenantMode | null | undefined;
}

export default function TenantModeChip({ mode, ...otherProps }: Props) {
  if (
    !mode ||
    mode === TenantMode.None ||
    (EnvHelper.isProductionAny && mode === TenantMode.Live)
  ) {
    return null;
  }
  return (
    <AppTooltip title={`Company mode`} isDefaultEnterDelays>
      <AppChip
        variant='outlined'
        size='small'
        color='default'
        label={<InlineApiEnumValue type={ApiEnumName.TenantMode} value={mode} />}
        {...otherProps}
      />
    </AppTooltip>
  );
}
